<dx-popup
    #workOrderSelector
    width="60%"
    height="70%"
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [visible]="visible"
    (onShown)="onWorkOrderShown()"
    (onHidden)="onWorkOrderClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <app-work-order
                        #workOrderMain
                        [isPopup]="true"
                        [communityId]="communityId"
                        [vendorId]="vendorId"
                        [workOrderIds]="workOrders"
                        [workflowId]="workflowId"
                        [showOnlyLinked]="showOnlyLinked"
                        (onWorkOrderSelection)="onWorkOrderIdsSelection($event)"
                        (onWorkOrderDeselection)="onWorkOrderIdsDeselection($event)"
                    ></app-work-order>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%" class="toolbar-container">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onWorkOrderClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="!showOnlyLinked" location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Add New WorkOrder"
                                    hint="Add New WorkOrder"
                                    [icon]="iconAdd"
                                    (onClick)="onAddNewWorkOrder()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="!showOnlyLinked" location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [disabled]="isSaveDisabled()"
                                    [icon]="iconCheck"
                                    (onClick)="onWorkOrderSave()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item *ngIf="showOnlyLinked" location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Ok"
                                    hint="Ok"
                                    [icon]="iconCheck"
                                    (onClick)="onMarkWorkOrderCompleted()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<!-- Add New Workorder -->
<app-work-orders-editor
    *ngIf="showWorkOrderEditor"
    [communityId]="communityId"
    [workOrderId]="workOrderId"
    [workflowId]="workflowId"
    [vendorCode]="vendorCode"
    (onClose)="onEditorClose($event)"
    (onManageProposalShow)="onManageProposalShow($event)"
    (onManageWorkAuthorizationShow)="onManageWorkAuthorizationShow($event)"
></app-work-orders-editor>

<app-manage-work-order-authorization
    *ngIf="showManageWorkAuthorization"
    [workOrderId]="workOrderId"
    [communityId]="communityId"
    (onClose)="onManageWorkorderAuthorizationClose()"
    (onManageProposalShow)="onManageProposalShow()"
    (onWorkOrderEditorShow)="onWorkOrderEditorShow()"
></app-manage-work-order-authorization>

<app-manage-work-order-proposals
    *ngIf="showManageProposals"
    [workOrderId]="workOrderId"
    [communityId]="communityId"
    (onClose)="onManageProposalClose()"
    (onWorkOrderEditorShow)="onWorkOrderEditorShow()"
    (onManageWorkAuthorizationShow)="onManageWorkAuthorizationShow()"
></app-manage-work-order-proposals>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: 'body' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
